import { FC } from "react";
import classnames from "classnames";
import { StyledGroup } from "./style";
import { SpaceProps } from "../../../../styled";

interface IProps extends SpaceProps {
  className?: string;
  style?: React.CSSProperties;
}

export const FormGroup: FC<IProps> = ({
  children,
  className,
  style,
  ...rest
}) => {
  return (
    <StyledGroup
      className={classnames(className, "form-group")}
      {...rest}
      style={style}
    >
      {children}
    </StyledGroup>
  );
};
